<template>
  <div>
    <b-modal id="serviceConfiguration" title="Service Hands-on-fees" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Service Hands-On Fee
        </div>
      </template>

      <div v-if="show" class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <div class="lock-header">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th rowspan="2" style="vertical-align: middle">Service</th>
                    <th :colspan="selectedStaffs.length + 1" style="text-align: center;">Hands-On Fee</th>
                  </tr>
                  <tr>
                    <th style="min-width: 100px" v-for="(staff, index) of selectedStaffs" :key="'staffHead' + index">{{ staff['name'] }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(service, index) of selectedServices" :key="'service_' + index">
                    <td>
                      <label class="form-label">{{ service['name'] }}</label>
                    </td>
                    <td v-for="(staff, index) of selectedStaffs" :key="'staffValue' + index">
                        <input
                          class="form-control"
                          v-model="fee[service['id']][staff['staffID']]"
                          type="number"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "serviceConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      services: [],
      selectedServices: [],

      selectedOutlet: {},
      selectedStaffs: [],

      show: false,

      staffs: [],
      fee: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('serviceConfiguration')

      this.loadStaff()
    },

    onOutletChange() {
      this.effort = {}

      if(this.staffs.length > 0) {
        this.loadCommission()
      }
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedServices.splice(0, this.selectedServices.length)

      for (let service of this.services) {
        if (service['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedServices.push({ id: service['skuID'], name: service['name'] })
        }
      }
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs || {}
          this.loadSection()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadService()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadService() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=1&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.services = response.data.skus
          this.filterBySection(this.selectedSection)
          this.onOutletChange()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.selectedStaffs = this.staffs.filter(k => k['outletID'] === this.selectedOutlet.id)

      // for(let service of this.sections) {
      //   this.fee[service['sectionID']] = {}
      //   this.fee[service['sectionID']][''] = ''

      //   for(let staff of this.selectedStaffs) {
      //     this.fee[service['sectionID']][staff['staffID']] = ''
      //   }
      // }

      for(let service of this.services) {
        this.fee[service['skuID']] = {}
        // this.fee[service['skuID']][''] = ''

        for(let staff of this.selectedStaffs) {
          this.fee[service['skuID']][staff['staffID']] = ''
        }
      }
      
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_VIISkin_fixedCommission_service_setting_202409`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_VIISkin_fixedCommission_service_setting_202409`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false

          response.data = response.data || {"1010630":{"53796":"12","53797":"10"},"1010631":{"53796":"10","53797":"8"},"1010632":{"53796":"12","53797":"10"},"1010635":{"53796":"12","53797":"10"},"1010639":{"53796":"12","53797":"10"},"1010641":{"53796":"12","53797":"10"},"1010643":{"53796":"12","53797":"10"},"1010649":{"53796":"6","53797":"4"},"1010650":{"53796":"4","53797":"3"},"1010651":{"53796":"4","53797":"3"},"1010652":{"53796":"7","53797":"4"},"1010653":{"53796":"7","53797":"4"},"1010654":{"53796":"6","53797":"4","54146":""},"1010655":{"53796":"6","53797":"4","54146":""},"1010656":{"53796":"7","53797":"4","54146":""},"1010657":{"53796":"6","53797":"6","54146":""},"1010659":{"53796":"6","53797":"3"},"1010660":{"53796":"18","53797":"18"},"1010661":{"53796":"12","53797":"8"},"1010662":{"53796":"5","53797":"3","54146":""},"1010663":{"53796":"5","53797":"3"},"1010664":{"53796":"5","53797":"3"},"1010665":{"53796":"2","53797":"2"},"1010666":{"53796":"2","53797":"2"},"1010667":{"53796":"0","53797":"0"},"1010672":{"53796":"5","53797":"4"},"1010673":{"53796":"1.5","53797":"1.5"},"1010674":{"53796":"6","53797":"5"},"1010677":{"53796":"6","53797":"5"},"1010680":{"53796":"6","53797":"5"},"1010684":{"53796":"6","53797":"5"},"1010686":{"53796":"6","53797":"5"},"1010688":{"53796":"6","53797":"5"},"1010690":{"53796":"6","53797":"5"},"1010692":{"53796":"3","53797":"2"},"1010693":{"53796":"2.50","53797":"1.50"},"1010694":{"53796":"2.50","53797":"1.50"},"1010695":{"53796":"3.5","53797":"2"},"1010696":{"53796":"3.5","53797":"2"},"1010697":{"53796":"2.5","53797":"1.5"},"1010698":{"53796":"9","53797":"9"},"1010699":{},"1010700":{"53796":"6","53797":"4"},"1010702":{"53796":"3","53797":"2"},"1010703":{"53796":"3","53797":"2"},"1010704":{"53796":"3.5","53797":"2"},"1010705":{"53796":"3","53797":"2"},"1010706":{"53796":"1","53797":"1"},"1010707":{"53796":"1","53797":"1"},"1010708":{"53796":"0","53797":"0"},"1010891":{"53796":"24","53797":"18"},"1010892":{"53796":"16","53797":"12"},"1010894":{"53796":"8","53797":"6"},"1010895":{"53796":"8","53797":"6"},"1010896":{"53796":"8","53797":"6"},"1010897":{"53796":"8","53797":"6"},"1010898":{"53796":"6","53797":"4"},"1010899":{"53796":"5","53797":"3"},"1010900":{"53796":"5","53797":"3"},"1010901":{"53796":"6","53797":"4"},"1010902":{"53796":"6","53797":"4"},"1010903":{"53796":"5","53797":"3"},"1010904":{"53796":"5","53797":"3"},"1010905":{"53796":"6","53797":"4"},"1010906":{"53796":"5","53797":"3"},"1010907":{"53796":"5","53797":"3"},"1010908":{"53796":"10","53797":"6"},"1010910":{"53796":"10","53797":"8"},"1010911":{"53796":"12","53797":"10"},"1010915":{"53796":"8","53797":"8"},"1010917":{"53796":"12","53797":"10"},"1010920":{"53796":"18","53797":"15"},"1010923":{"53796":"12","53797":"10"},"1010925":{"53796":"12","53797":"10"},"1010927":{"53796":"12","53797":"10"},"1011086":{"53796":"3","53797":"3"},"1011092":{"53796":"1.5","53797":"1.5"},"1011106":{"53796":"6","53797":"6"},"1011113":{"53796":"5","53797":"4"},"1012948":{},"1019144":{},"1026532":{"53796":"6","53797":"5"},"1026542":{"53796":"0","53797":"0"},"1026543":{"53796":"0","53797":"0"},"1026544":{"53796":"2.5","53797":"1.5"},"1026545":{"53796":"2.5","53797":"1.5"},"1026552":{"53796":"1.5","53797":"1.5"},"1031385":{"53796":"12","53797":"10"},"1031386":{"53796":"3","53797":"3"},"1031406":{"53796":"3","53797":"3"},"1031407":{"53796":"3","53797":"3"},"1031475":{"53796":"3","53797":"3"},"1032482":{},"1034442":{},"1034455":{},"1035115":{"53796":"1.5","53797":"15"},"1035862":{},"1037085":{"53796":"6","53797":"4"},"1037088":{"53796":"5","53797":"5"},"1040646":{"53796":"3","53797":"2","54146":""},"1040649":{"53796":"3","53797":"3"},"1040650":{"53796":"1.5","53797":"1"},"1056771":{},"1058889":{"53796":"10","53797":"8"},"1058897":{"53796":"10","53797":"8"},"1059152":{"53796":"5","53797":"4"},"1059231":{"53796":"5","53797":"4"},"1060773":{"53796":"8","53797":"6"},"1067421":{"53796":"6","53797":"4"},"1067422":{"53796":"10","53797":"8"},"1067426":{"53796":"3","53797":"3"},"1067427":{"53796":"3","53797":"3"},"1067429":{"53796":"3","53797":"1.5"},"1068507":{},"1068508":{},"1068509":{"53796":"5","53797":"4"},"1068510":{},"1068511":{"53796":"3","53797":"2"},"1068512":{},"1068694":{"53796":"3","53797":"3"},"1068708":{"53796":"1","53797":".5"},"1068709":{"53796":"1","53797":".5"},"1068710":{"53796":"1","53797":".5"},"1068711":{"53796":"1","53797":".5"},"1068712":{"53796":"1","53797":".5"},"1068716":{"53796":"2","53797":"1"},"1068717":{"53796":"2","53797":"1"},"1068719":{"53796":"2","53797":"1"},"1068720":{"53796":"2","53797":"1"},"1068723":{"53796":"2","53797":"1"},"1068724":{"53796":"2","53797":"1"},"1068725":{"53796":"2","53797":"1"},"1068733":{"53796":"1","53797":".5"},"1068735":{"53796":"1","53797":".5"},"1068736":{"53796":"0","53797":"0"},"1068738":{"53796":"2","53797":"1"},"1068741":{"53796":"2","53797":"1"},"1068743":{"53796":"1","53797":".5"},"1068744":{"53796":"2","53797":"1"},"1068748":{"53796":"2","53797":"1"},"1068751":{},"1068753":{"53796":"0","53797":"0"},"1068793":{"53796":"1.5","53797":"1.5"}}

          // for(let service of this.sections) {
          //   this.fee[service['sectionID']] = response.data[service['sectionID']] || {}
          //   this.fee[service['sectionID']][''] = this.fee[service['sectionID']][''] || ''
          // }

          for(let service of this.services) {
            if (typeof response.data[service['skuID']] === "string") {
              delete response.data[service['skuID']]
            }

            this.fee[service['skuID']] = response.data[service['skuID']] || {}
            // for(let staff of this.selectedStaffs) {
            //   this.fee[service['skuID']][staff['staffID']] = (response.data[service['skuID']] || {})[staff['staffID']] || ''
            // }
          }

          this.show = true

          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = this.fee
      console.log(this.fee)

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_VIISkin_fixedCommission_service_setting_202409`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_VIISkin_fixedCommission_service_setting_202409`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('serviceConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}

.lock-header {
	overflow: -moz-scrollbars-vertical; 
  overflow-y: scroll;
  /* max-height: 75vh; */
}

.lock-header thead {
  position: sticky;
  top: 0;
	background-color: #fff;
	z-index: 11;
}

.lock-header td:nth-child(1) {
  position: sticky;
  left: 0;
	background-color: #fff;
  z-index: 10;
}

.lock-header tr:nth-of-type(odd) td:nth-child(1) {
    background-color: #f4f4f4;
}
</style>